
import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import SequencerOperation from "models/audioEditor/sequencerOperation/SequencerOperation";
import ReplacementSequencerNode from "models/audioEditor/sequencerNodes/ReplacementSequencerNode";
import StartWrapSequencerNode from "models/audioEditor/sequencerNodes/StartWrapSequencerNode";
import EndWrapSequencerNode from "models/audioEditor/sequencerNodes/EndWrapSequencerNode";
import Utils from "models/helper/Utils";
import RSVP from "rsvp";

const MoveWrapNodesOperation =  SequencerOperation.extend({
    idAttribute: "id",


    constructor: function(attributes, options) {
        SequencerOperation.apply(this, [attributes, options]);
    },

    execute : function(startOrEndWrapSequencerNodeToMove,oldIndexInSequencer,  newIndexInSequencer, newPreviousSequencerNode, newNextSequencerNode){
        const isStartWrapSequencerNode = startOrEndWrapSequencerNodeToMove instanceof StartWrapSequencerNode ? startOrEndWrapSequencerNodeToMove : false;
        const isEndWrapSequencerNode = startOrEndWrapSequencerNodeToMove instanceof EndWrapSequencerNode ? startOrEndWrapSequencerNodeToMove : false;
        if(!isEndWrapSequencerNode && !isStartWrapSequencerNode){
            return null;
        }
        let changeStartNode = null;
        const oldStartWrappedNode = startOrEndWrapSequencerNodeToMove.getStartWrappedNode();
        const oldEndWrappedNode = startOrEndWrapSequencerNodeToMove.getEndWrappedNode();
        let newStartWrappedNode = null;
        let newEndWrappedNode = null;
        if(isStartWrapSequencerNode){
            newStartWrappedNode = newNextSequencerNode;
            newEndWrappedNode = startOrEndWrapSequencerNodeToMove.getEndWrappedNode();
            changeStartNode = true;
        }else{
            newStartWrappedNode = startOrEndWrapSequencerNodeToMove.getStartWrappedNode();
            newEndWrappedNode = newPreviousSequencerNode;
            changeStartNode = false;
        }
        if(!newStartWrappedNode || !newEndWrappedNode){
            //invalid wrap
            return null;
        }
        if(!(oldStartWrappedNode === newStartWrappedNode &&  oldEndWrappedNode === newEndWrappedNode) && startOrEndWrapSequencerNodeToMove.canWrapTo(newStartWrappedNode, newEndWrappedNode)){
            let wrapChanged = false;
            if(changeStartNode){
                newStartWrappedNode = startOrEndWrapSequencerNodeToMove.getSelectableStartNodeWrappedIfApplicable(newStartWrappedNode);
                wrapChanged = startOrEndWrapSequencerNodeToMove.changeStartNodeToWrapTo(newStartWrappedNode);
            }else{
                newEndWrappedNode = startOrEndWrapSequencerNodeToMove.getSelectableEndNodeWrappedIfApplicable(newEndWrappedNode);
                wrapChanged = startOrEndWrapSequencerNodeToMove.changeEndNodeToWrapTo(newEndWrappedNode);
            }
            if(!wrapChanged){
                return null;
            }
            this.getSequencer().getHistoryManagement().addSequencerOperationMoveWrapNodesLog(startOrEndWrapSequencerNodeToMove, changeStartNode, oldStartWrappedNode,oldEndWrappedNode,newStartWrappedNode, newEndWrappedNode);
            this._notifyParagraphStructureChanged();
            return true;
        }else{
            //invalid wrap
            return null;
        }

    },

    undo: function(sequencerOperationMoveWrapNodesLog){
        const startOrEndWrapSequencerNodeToMove = sequencerOperationMoveWrapNodesLog.getStartOrEndWrapSequencerNodeToMove();
        const changeStartNode = sequencerOperationMoveWrapNodesLog.getChangeStartNode();
        const oldStartWrappedNode = sequencerOperationMoveWrapNodesLog.getOldStartWrappedNode();
        const oldEndWrappedNode = sequencerOperationMoveWrapNodesLog.getOldEndWrappedNode();
        let wrapChanged = false;
        if(changeStartNode){
            wrapChanged = startOrEndWrapSequencerNodeToMove.changeStartNodeToWrapTo(oldStartWrappedNode);
        }else{
            wrapChanged = startOrEndWrapSequencerNodeToMove.changeEndNodeToWrapTo(oldEndWrappedNode);
        }
        if(!wrapChanged){
            return false;
        }
        this._notifyParagraphStructureChanged();
        return true;
    },

    redo: function(sequencerOperationMoveWrapNodesLog){
        const startOrEndWrapSequencerNodeToMove = sequencerOperationMoveWrapNodesLog.getStartOrEndWrapSequencerNodeToMove();
        const changeStartNode = sequencerOperationMoveWrapNodesLog.getChangeStartNode();
        const newStartWrappedNode = sequencerOperationMoveWrapNodesLog.getNewStartWrappedNode();
        const newEndWrappedNode = sequencerOperationMoveWrapNodesLog.getNewEndWrappedNode();
        let wrapChanged = false;
        if(changeStartNode){
            wrapChanged = startOrEndWrapSequencerNodeToMove.changeStartNodeToWrapTo(newStartWrappedNode);
        }else{
            wrapChanged = startOrEndWrapSequencerNodeToMove.changeEndNodeToWrapTo(newEndWrappedNode);
        }
        if(!wrapChanged){
            return false;
        }
        this._notifyParagraphStructureChanged();
        return true;
    },

    

});

export default MoveWrapNodesOperation; 
